import React from 'react';
import PropTypes from 'prop-types';
import styles from './StudentImport.module.sass';

// Large white text on solid red, for the few things on the import screens that
// must not be read past. What counts as serious is decided in
// utils/studentImportSeriousWarnings.js; this only draws it. Keep it rare --
// a page where everything is red is the same page as one where nothing is.
const SeriousWarning = ({ title, items, note }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={styles.seriousWarning} role="alert">
      <p className={styles.seriousWarningTitle}>{title}</p>
      <ul className={styles.seriousWarningList}>
        {items.map((item) => (
          <li key={item.key}>{item.message}</li>
        ))}
      </ul>
      {note && <p className={styles.seriousWarningNote}>{note}</p>}
    </div>
  );
};

SeriousWarning.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  })),
  note: PropTypes.string,
};
SeriousWarning.defaultProps = { items: [], note: null };

export default SeriousWarning;
